import type { Space } from "@circle-react/types/Space";
import {
  Select,
  type SearchableSelectProps,
} from "@circleco/compass/components/Select";

import { t } from "@/i18n-js/instance";

import { useSpaceSelectOptions } from "./useSpaceSelectOptions";

const I18N_ROOT = "space_select_compass";

export interface SpaceSelectCompassComponentProps extends Omit<
  SearchableSelectProps<number>,
  "options" | "value" | "onValueChange" | "i18n" | "defaultValue" | "searchable"
> {
  "data-testid"?: string;
  onChange?: (id: number | null) => void;
  shouldDisplayHomepage?: boolean;
  shouldShowEmoji?: boolean;
  spaces?: Space[];
  value?: number | null;
}

export const SpaceSelectCompassComponent = ({
  "data-testid": dataTestId = "space-selector",
  onChange,
  shouldDisplayHomepage,
  shouldShowEmoji = true,
  spaces = [],
  value,
  ...selectProps
}: SpaceSelectCompassComponentProps) => {
  const { options, selectedOption } = useSpaceSelectOptions({
    spaces,
    value,
    shouldDisplayHomepage,
    shouldShowEmoji,
  });

  const placeholder = selectProps.placeholder ?? t([I18N_ROOT, "placeholder"]);

  return (
    <Select
      options={options}
      value={selectedOption}
      data-testid={dataTestId}
      {...selectProps}
      searchable
      onValueChange={opt => {
        onChange?.(opt?.value ?? null);
      }}
      placeholder={placeholder}
      emptyMessage={t([I18N_ROOT, "empty_message"])}
      i18n={{
        searchPlaceholder: t([I18N_ROOT, "search_placeholder"]),
      }}
    />
  );
};

SpaceSelectCompassComponent.displayName = "SpaceSelectCompass";
